(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (slider) => {
      if (slider.dataset.sliderReady === 'true') return;
      slider.dataset.sliderReady = 'true';

      const slides = [...slider.querySelectorAll('[data-hero-slide]')];
      const dots = [...slider.querySelectorAll('[data-hero-dot]')];
      const previous = slider.querySelector('[data-hero-prev]');
      const next = slider.querySelector('[data-hero-next]');
      const track = slider.querySelector('.home-hero-slider__track');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const shouldAutoplay = slider.dataset.autoplay === 'true' && !reduceMotion;
      const interval = Math.max(Number(slider.dataset.interval) || 7000, 4000);
      let activeIndex = 0;
      let timer;
      let touchStartX = 0;

      const show = (index, userInitiated = false) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (userInitiated) restart();
      };

      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (shouldAutoplay) timer = window.setInterval(() => show(activeIndex + 1), interval);
      };
      const restart = () => {
        stop();
        start();
      };

      previous?.addEventListener('click', () => show(activeIndex - 1, true));
      next?.addEventListener('click', () => show(activeIndex + 1, true));
      dots.forEach((dot, index) => dot.addEventListener('click', () => show(index, true)));

      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (event) => {
        if (!slider.contains(event.relatedTarget)) start();
      });
      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(activeIndex - 1, true);
        if (event.key === 'ArrowRight') show(activeIndex + 1, true);
      });
      slider.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX || 0;
        stop();
      }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        const touchEndX = event.changedTouches[0]?.clientX || 0;
        const distance = touchEndX - touchStartX;
        if (Math.abs(distance) > 48) show(activeIndex + (distance < 0 ? 1 : -1), true);
        else start();
      }, { passive: true });
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());

      if (track) track.setAttribute('aria-live', shouldAutoplay ? 'off' : 'polite');
      show(0);
      start();
    };

    const initializeAll = (root = document) => root.querySelectorAll('[data-home-hero-slider]').forEach(initialize);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
